import React from "react";
import { Link } from "react-router-dom";
import { useSiteData } from "../context/SiteDataContext";

const Home: React.FC = () => {
  const { data } = useSiteData();

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <span className="hero-badge">{data.hero.badge}</span>
          <h1>
            {data.hero.title1}
            <br />
            <span>{data.hero.title2}</span>
          </h1>
          <p>{data.hero.description}</p>
          <div className="hero-actions">
            <Link to="/portfoy" className="btn-primary">
              Projelerimi İncele
            </Link>
            <Link to="/iletisim" className="btn-secondary">
              İletişime Geç
            </Link>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">{data.hero.stat1Number}</span>
              <span className="stat-label">{data.hero.stat1Label}</span>
            </div>
            <div className="stat">
              <span className="stat-number">{data.hero.stat2Number}</span>
              <span className="stat-label">{data.hero.stat2Label}</span>
            </div>
            <div className="stat">
              <span className="stat-number">{data.hero.stat3Number}</span>
              <span className="stat-label">{data.hero.stat3Label}</span>
            </div>
            <div className="stat">
              <span className="stat-number">{data.hero.stat4Number}</span>
              <span className="stat-label">{data.hero.stat4Label}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Ne Yapıyorum?</h2>
            <p>Üç ana alanda uzmanlaşmış hizmetler sunuyorum</p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🎨</div>
              <h3>{data.services.web.title}</h3>
              <p>{data.services.web.description}</p>
              <ul className="service-features">
                {data.services.web.features.map((feat, idx) => (
                  <li key={idx}>{feat}</li>
                ))}
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">🎙️</div>
              <h3>{data.services.ses.title}</h3>
              <p>{data.services.ses.description}</p>
              <ul className="service-features">
                {data.services.ses.features.map((feat, idx) => (
                  <li key={idx}>{feat}</li>
                ))}
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">📺</div>
              <h3>{data.services.canli.title}</h3>
              <p>{data.services.canli.description}</p>
              <ul className="service-features">
                {data.services.canli.features.map((feat, idx) => (
                  <li key={idx}>{feat}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-light">
        <div className="container" style={{ textAlign: "center" }}>
          <h2 style={{ fontSize: "2rem", marginBottom: "16px" }}>
            Projenizi Hayata Geçirelim
          </h2>
          <p
            style={{
              color: "var(--text-medium)",
              maxWidth: "500px",
              margin: "0 auto 32px",
            }}
          >
            İster yeni bir web sitesi, ister profesyonel sesli yazıya çeviri
            hizmeti olsun, doğru adrestesiniz.
          </p>
          <Link to="/iletisim" className="btn-primary">
            Hemen Başlayalım
          </Link>
        </div>
      </section>
    </>
  );
};

export default Home;
